import { useEffect, useState } from 'react';
import { shortcuts as request } from '@myua/api';

export function useResource<T>(url?: string) {
  const [data, setData] = useState<T | undefined>();
  const [status, setStatus] = useState<number | null>();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!url) {
      return;
    }

    const controller = new AbortController();

    async function loadURL(url: string): Promise<{ response: T; status: number } | undefined> {
      try {
        const result = await request.get<T>({ url, signal: controller.signal });

        const { response, status } = result;
        return { response, status };
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        if ((error as any)?.error?.name === 'AbortError') {
          return;
        }
        setError(true);

        //getting response status and message from server
        const e = error as { error?: string; status?: number };
        if (e.status) setStatus(e.status);
        if (e.error)
          setErrorMessage(
            `Can not load data from:\n ${url ?? '<url not provided>'},\nServer response: ${e.status ?? ''} ${e.error ?? 'No error details'}` +
              `\n\nPlease contact your system admin or support chat`,
          );
      }
    }

    setError(false);
    setData(undefined);
    setStatus(null);

    void loadURL(url).then((args) => {
      if (args === undefined) return;
      const { response, status } = args;
      if (response) {
        setData(response);
        setStatus(status);
      }
    });

    return () => {
      controller.abort();
    };
  }, [url]);

  return { data, error, status, errorMessage };
}
